<template>
  <div>
    <section class="section title-background">
      <div class="container">
        <div class="columns">
          <div class="column">
            <div class="m-2">
              <h2 class="title is-size-2">Infografías</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="container">

      <div class="columns mt-01">

        <div class="column is-3">
          <img src="/assets/img/infografias/afiliacion.jpg" alt="Afiliación Voluntaria" @click="imageSelected('/assets/img/infografias/afiliacion.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/contracambio.jpg" alt="Contracambio el cambio climatico" @click="imageSelected('/assets/img/infografias/contracambio.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/contralatrata.jpg" alt="Contra la trata de personas" @click="imageSelected('/assets/img/infografias/contralatrata.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/empleo.jpg" alt="Empleo y productividad" @click="imageSelected('/assets/img/infografias/empleo.jpg')"/>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-3">
          <img src="/assets/img/infografias/culturasalud.jpg" alt="Cultura de la Salud" @click="imageSelected('/assets/img/infografias/culturasalud.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/deporte.jpg" alt="Deportes" @click="imageSelected('/assets/img/infografias/deporte.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/educacion.jpg" alt="Educación" @click="imageSelected('/assets/img/infografias/educacion.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/eventoscon1.jpg" alt="Eventos Comemorativos" @click="imageSelected('/assets/img/infografias/eventoscon1.jpg')"/>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-3">
          <img src="/assets/img/infografias/eventoscon2.jpg" alt="Eventos Comemorativos" @click="imageSelected('/assets/img/infografias/eventoscon2.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/eventoscon3.jpg" alt="Eventos Comemorativos" @click="imageSelected('/assets/img/infografias/eventoscon3.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/orientacion.jpg" alt="Orientación" @click="imageSelected('/assets/img/infografias/orientacion.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/politica1.jpg" alt="Participación Política" @click="imageSelected('/assets/img/infografias/politica1.jpg')"/>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-3">
          <img src="/assets/img/infografias/politica2.jpg" alt="Participación Política" @click="imageSelected('/assets/img/infografias/politica2.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/politica3.jpg" alt="Participación Política" @click="imageSelected('/assets/img/infografias/politica3.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/politica4.jpg" alt="Participación Política" @click="imageSelected('/assets/img/infografias/politica4.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/politica5.jpg" alt="Participación Política" @click="imageSelected('/assets/img/infografias/politica5.jpg')"/>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-3">
          <img src="/assets/img/infografias/politica6.jpg" alt="Participación Política" @click="imageSelected('/assets/img/infografias/politica6.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/politica7.jpg" alt="Participación Política" @click="imageSelected('/assets/img/infografias/politica7.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/politica8.jpg" alt="Participación Política" @click="imageSelected('/assets/img/infografias/politica8.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/politica9.jpg" alt="Participación Política" @click="imageSelected('/assets/img/infografias/politica9.jpg')"/>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-3">
          <img src="/assets/img/infografias/prevencionadicciones.jpg" alt="Prevención a adicciones" @click="imageSelected('/assets/img/infografias/prevencionadicciones.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/prevenciondelito.jpg" alt="Prevención al delito" @click="imageSelected('/assets/img/infografias/prevenciondelito.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/sabados.jpg" alt="Sábados Familiares" @click="imageSelected('/assets/img/infografias/sabados.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/tecnologia.jpg" alt="Tecnología Domestica" @click="imageSelected('/assets/img/infografias/tecnologia.jpg')"/>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-3">
          <img src="/assets/img/infografias/turismo.jpg" alt="Turismo Social" @click="imageSelected('/assets/img/infografias/turismo.jpg')"/>
        </div>

        <div class="column is-3">
          <img src="/assets/img/infografias/vivienda.jpg" alt="Vivienda para todos" @click="imageSelected('/assets/img/infografias/vivienda.jpg')"/>
        </div>

      </div>


    </div>

    <modal v-show="showModal" :imageselected="imageselected" @close="showModal = false"></modal>


  </div>
</template>

<script>
import Modal from '@/components/layouts/partials/modal'

export default {
  name: 'SesionesOrdinarias',
  data () {
    return {
      showModal: false,
      imageselected:'',
    }
  },
  computed: {
  },
  components: {
    Modal
  },
  mounted() {

  },
  methods:{
    imageSelected(img){
      this.imageselected=img;
      this.showModal = true;
    },
  },
  created :function(){

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Infografias.vue